import { Map, MapMarker } from 'react-kakao-maps-sdk';

const PreviewPinAddress = ({ position, setShowPopupMap }) => {
    return (
        <div className="cropPop" id="popupMap">
            <div className="cropPop__container">
                <button
                    id="cropPopClose"
                    type="button"
                    className="popupMap__close"
                    onClick={() => setShowPopupMap(false)}
                />
                <div className="cropPop__block">
                    <Map style={{ width: '100%', height: '500px' }} center={position} level={3}>
                        <MapMarker position={position} />
                    </Map>
                </div>
            </div>
        </div>
    );
};
export default PreviewPinAddress;
